import { getWindowData } from 'owa-window-data';

export function isTdsBox() {
    return getWindowData().location.host === 'exchangelabs.live-int.com';
}
